//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      // xbiodata_id : this.biodata_id,
      list_riwayat: [],
      list_pendidikan :[],
      list_jns:[],
      pendidikan : {

          idRiwayatKursus               : '',
          idPns                         : '',
          biodata_id                    : this.biodata_id,
          institusiPenyelenggara        : '',
          jenisDiklatId                 : '',
          jenisKursusId                 : '',
          jenisKursusNama               : '',
          jenisKursusSertifikat         : '',
          jumlahJam                     : 0,
          namaKursus                    : '',
          nipBaru                       : '',
          nipLama                       : '',
          noSertipikat                  : '',
          tahunKursus                   : '',
          tanggalKursus                 : '',
          tanggalSelesaiKursus          : '',
          lokasi                        : '',
          file                          : null,
          userId                        : '',
          createdAt                     : '',
          status                        : 1,
          keterangan                    : '',    

      },

      dummy : {
        jns_latihan_struktural_id : null,
      },


      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      mdl_kembalikan_data: false,
      mdl_keterangan: false,
      file_old :'',

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,

      btn_add: false,


      tab: 'disetujui',


      loadRiwayatSIA : true,
      fileLoadSIA :true,
      fileLoadEmpty : false,
      fileRiwayat : null,
      // kodeDok : '874',
      kodeDok : '881', //kursus


      status :1,



    };
  },

  methods: {
    getRiwayat: function(){

      this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_riwayat_kursus+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.pendidikan.biodata_id,
              status : this.status
            })
        }).then((res) => res.json()).then((res_data) => {
          this.list_pendidikan = res_data;
          this.loadRiwayatSIA = false;
          console.log(res_data);
        })
    },

    addData : function() {


      var formData = new FormData();

      formData.append('idRiwayatKursus',             this.pendidikan.idRiwayatKursus);
      formData.append('idPns',                       this.pendidikan.idPns);
      formData.append('biodata_id',                  this.pendidikan.biodata_id);
      formData.append('institusiPenyelenggara',      this.pendidikan.institusiPenyelenggara);
      formData.append('jenisDiklatId',               this.pendidikan.jenisDiklatId);
      formData.append('jenisKursusId',               this.pendidikan.jenisKursusId);
      formData.append('jenisKursusNama',             this.pendidikan.jenisKursusNama);
      formData.append('jenisKursusSertifikat',       this.pendidikan.jenisKursusSertifikat);
      formData.append('jumlahJam',                   this.pendidikan.jumlahJam);
      formData.append('namaKursus',                  this.pendidikan.namaKursus);
      formData.append('nipBaru',                     this.pendidikan.nipBaru);
      formData.append('nipLama',                     this.pendidikan.nipLama);
      formData.append('noSertipikat',                this.pendidikan.noSertipikat);
      formData.append('tahunKursus',                 this.pendidikan.tahunKursus);
      formData.append('tanggalKursus',               this.pendidikan.tanggalKursus);
      formData.append('tanggalSelesaiKursus',        this.pendidikan.tanggalSelesaiKursus); 
      formData.append('lokasi',                      this.pendidikan.lokasi); 
      formData.append('userId',                      this.pendidikan.userId);
      formData.append('createdAt',                   this.pendidikan.createdAt);
      formData.append('status',                      this.pendidikan.status);
      formData.append('keterangan',                  this.pendidikan.keterangan);
      
      // console.log(this.pendidikan);

      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok); 
      formData.append('file', this.pendidikan.file);

      fetch(this.$store.state.url.URL_simpeg_riwayat_kursus+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then((data_urusan) => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getRiwayat();
      });
     
    },


    editData : function(){

      var formData = new FormData();

      formData.append('idRiwayatKursus',             this.pendidikan.idRiwayatKursus);
      formData.append('idPns',                       this.pendidikan.idPns);
      formData.append('biodata_id',                  this.pendidikan.biodata_id);
      formData.append('institusiPenyelenggara',      this.pendidikan.institusiPenyelenggara);
      formData.append('jenisDiklatId',               this.pendidikan.jenisDiklatId);
      formData.append('jenisKursusId',               this.pendidikan.jenisKursusId);
      formData.append('jenisKursusNama',             this.pendidikan.jenisKursusNama);
      formData.append('jenisKursusSertifikat',       this.pendidikan.jenisKursusSertifikat);
      formData.append('jumlahJam',                   this.pendidikan.jumlahJam);
      formData.append('namaKursus',                  this.pendidikan.namaKursus);
      formData.append('nipBaru',                     this.pendidikan.nipBaru);
      formData.append('nipLama',                     this.pendidikan.nipLama);
      formData.append('noSertipikat',                this.pendidikan.noSertipikat);
      formData.append('tahunKursus',                 this.pendidikan.tahunKursus);
      formData.append('tanggalKursus',               this.pendidikan.tanggalKursus);
      formData.append('tanggalSelesaiKursus',        this.pendidikan.tanggalSelesaiKursus); 
      formData.append('userId',                      this.pendidikan.userId);
      formData.append('createdAt',                   this.pendidikan.createdAt);
      formData.append('status',                      this.pendidikan.status);
      formData.append('keterangan',                  this.pendidikan.keterangan); 
      formData.append('file',                        this.pendidikan.file);
      formData.append('file_old',                    this.file_old);

      fetch(this.$store.state.url.URL_simpeg_riwayat_kursus+'updateData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then((res_data) => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getRiwayat();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_simpeg_riwayat_kursus + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.pendidikan.idRiwayatKursus, file : this.file_old})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getRiwayat();
      });

    },

    selectRiwayat: function(data){

          // console.log("selectRiwayat");
          // console.log(data);

          this.pendidikan.idRiwayatKursus            = data.idRiwayatKursus
          this.pendidikan.idPns                      = data.idPns
          this.pendidikan.biodata_id                 = data.biodata_id
          this.pendidikan.institusiPenyelenggara     = data.institusiPenyelenggara
          this.pendidikan.jenisDiklatId              = data.jenisDiklatId
          this.pendidikan.jenisKursusId              = data.jenisKursusId
          this.pendidikan.jenisKursusNama            = data.jenisKursusNama
          this.pendidikan.jenisKursusSertifikat      = data.jenisKursusSertifikat
          this.pendidikan.jumlahJam                  = data.jumlahJam
          this.pendidikan.namaKursus                 = data.namaKursus
          this.pendidikan.nipBaru                    = data.nipBaru
          this.pendidikan.nipLama                    = data.nipLama
          this.pendidikan.noSertipikat               = data.noSertipikat
          this.pendidikan.tahunKursus                = data.tahunKursus
          this.pendidikan.tanggalKursus              = data.tanggalKursus
          this.pendidikan.tanggalSelesaiKursus       = data.tanggalSelesaiKursus
          this.pendidikan.lokasi                     = data.lokasi
          this.pendidikan.userId                     = data.userId
          this.pendidikan.createdAt                  = data.createdAt
          this.pendidikan.status                     = data.status
          this.pendidikan.keterangan                 = data.keterangan



          if (data.status != 1) {
            this.fileLoadSIA = false
          //   this.file_old = data.path[this.kodeDok].realname;
            var dumx = data.path
            if (dumx.hasOwnProperty(this.kodeDok)) {
                this.file_old = data.path[this.kodeDok].realname;
                // console.log("truex");
            }else{
              this.file_old = data.path["874"].realname;
              // console.log("false");
            }
          }

          



          // console.log(data);

    },


    // assu : function(){
    //   console.log("aaaassssuuuu");
    // },



    // ====================================== INTEGRASI SI-ASN ====================================


    syncDataRiwayatSiASN: function(){

        this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_riwayat_kursus+'si_asn_viewOne', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              nip : this.nip,
              biodata_id : this.biodata_id,
              kode : this.kodeDok,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.Notify('Sukses Sync Data', 'warning', 'check_circle_outline');


          this.getRiwayat();

          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    approveUsulanDataRiwayatSiASN : async function(){


      this.pendidikan.nip = this.nip
      this.pendidikan.kode = '881'
      this.pendidikan.file_old = this.file_old

      var sex = await UMUM.alertConfirm("Verifikasi", "Apakah Anda yakin verifikasi data ini ?!", "Integrasi")

      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_riwayat_kursus + "approve", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pendidikan)
        }).then(res_data => {
            this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },

    deleteDataRiwayatSiASN : async function(){


      this.pendidikan.nip = this.nip
      this.pendidikan.kode = this.kodeDok

      var sex = await UMUM.alertConfirm("Hapus Data?", "Apakah Anda yakin ?!", "Hapus")

      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_riwayat_kursus + "si_asn_delete", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pendidikan)
        }).then(res_data => {
            this.Notify('Sukses menghapus Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },


    getDownloadSIASN: async function(file, kode) {


      console.log("ppppppppp");
      // console.log(file);
      console.log(kode);
      console.log("ppppppppp");

              
      if (file.path == null || file.path == undefined) {
        this.fileLoadEmpty = true
      //   console.log("FILE KOSONG");
      } else {
        this.fileLoadEmpty = false


      //   console.log(file);
        
        var fileGet = null
          if (file.path[kode] == undefined) {
              fileGet = file.path['874'].dok_uri
              console.log('874 =====>');
          }else{
              console.log('881 =====>');
              fileGet = file.path['881'].dok_uri
          }
      //   var fileGet = file.path[kode].dok_uri
        console.log("ini fileGet === " + fileGet);
        this.fileLoadSIA = true
        fetch(this.$store.state.url.URL_simpeg_home + "lampiran", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                fileURL: fileGet,
                id : file.idRiwayatKursus,
                kode : this.kodeDok,
            })
            })
            .then(response => response.text())
            .then(res_data => {


              //   console.log("INI DIA");
                console.log(res_data)
              //   console.log("INI DIA");
              //   console.log(typeof(res_data));

                this.fileRiwayat = res_data
                console.log(this.fileRiwayat);
                this.fileLoadSIA = false

              

        });




      }


    },

    kembalikan_data : function(E){
      fetch(this.$store.state.url.URL_simpeg_riwayat_kursus + "kembalikan_data", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.pendidikan)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getRiwayat();
      });

    },


    get_list_kursus(){
      // var data = UMUM.

      fetch(this.$store.state.url.URL_simpeg_riwayat_kursus + "list", {
          method : 'POST',
          headers : {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body : JSON.stringify({
            // unit_kerja : 'unit_kerja'

          })
      })
      .then((res) => res.json())
      .then((res_data) => {
        // store.state.list_strata_ijazah = res_data
        console.log("res_data =====> penghargaan")
        // console.log(res_data)
        this.list_jns = res_data
      })
      
    },


    cchontol(){

      if (this.pendidikan.jenisDiklatId != '1') {
        this.pendidikan.jns_latihan_struktural_id = '0'
      }
      console.log(this.pendidikan.jns_latihan_struktural_id);
    },

    cchontol1(){
      console.log(this.dummy.jns_latihan_struktural_id);
      this.pendidikan.uraian = this.dummy.jns_latihan_struktural_id.jns_latihan_struktural
      this.pendidikan.jns_latihan_struktural_id = this.dummy.jns_latihan_struktural_id.jns_latihan_struktural_id
    },



    // ====================================== INTEGRASI SI-ASN ====================================



    alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
    },
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {
    this.getRiwayat()
    this.get_list_kursus()
    DATA_MASTER.getGolongan();
    DATA_MASTER.getJnsDiklat();
    DATA_MASTER.getLatStruktural();
    DATA_MASTER.getJnsKompetensi();
  },



};
